const common = {
  serverError: 'Server error',
  networkError: 'Network error',

  del: 'Delete',
  rmTip: 'Delete tip',
  rmContent: 'Are you sure you want to delete this data? Data cannot be restored after deletion! ',
  rmError: 'Delete failed',
  rmSuccess: 'Delete succeeded',

  confirm: 'Confirm',
  cancel: 'Cancel',
  cancelConfirm: "Data has been changed, are you sure you don't want to save it? ",

  add: 'Add',
  addError: 'Add failed',
  addSuccess: 'Added successfully',

  edit: 'Edit',
  editError: 'Edit failed',
  editSuccess: 'Edit successfully',
  tip: 'Tip',

  opt: 'Operation',
  viewDetail: 'View details',
  detail: 'Details',

  desc: 'Description',
  plDesc: 'Please enter a description',

  pass: "Pass",
  no: "No",
  copy: 'Copy',
  copyError: ' Copy failed',
  copySuccess: ' Copy successful',

  printInfo: 'Print',
  printInfoQC: 'Print QC Inspection Sheet',
  paste: 'Paste',
  pasteError: 'Paste failed, please confirm that the copied content is normal or try again after copying',

  select: 'Select',
  searchError: "Get list exception",

  timeOption12: "12 hours",
  timeOption24: "1 day",
  timeOption36: "36 hours",
  timeOption48: "2 days",
  timeOption72: "3 days",
  timeOption96: "4 days",
  timeOption120: "5 days",
  currentTime: "Current time",
  selectTime: "Please select or fill in the time period available for suppliers to quote",
  or: "or",
  inputHours: "Enter the number of hours",
  hour: "hour",
  finalEnd: "Deadline for final quotation",
  upper: "After rounding up the current time",
  plus: "Add",

  refresh: "Refresh",
  sure: 'Are you sure you want to save it?',
  saveOk: 'Successfully saved',
  saveFAil: 'Save failed',
  save: 'Save',
  notSave: 'Don\'t Save',
  validateFailed: 'Form validation failed',

  createTime: "Order Creation Time",
  creator: "Order Creator",
  updateTime: 'Update time',
  updater: 'Updater',
  pleaseTryAgain: 'Please try again later',
  operationFailed: 'Operation failed',

  exportCurrentPage: 'Export Current Page to Excel',
  exportAllExcel: 'Export All to Excel',
  exporting: 'Exporting',
  exportingTip: 'Loading data in batches, please wait...',
  exportErr: 'Export failed',
  warning: 'Warning',
  pleaseSelectColumns: 'Please select at least one column to export',
  selectAll: 'Select All',
  expand: 'Expand More',
  collapse: 'Collapse',

  // Reimburse Category
  code: 'Code',
  name: 'Name',
  sortOrder: 'Sort Order',
  update: 'Update',
  updateSuccess: 'Update Successfully',
  addSub: 'Add Subcategory',
  disable: 'Disable',

  basicInfo: 'Basic Info',
  attachment: 'Attachment',
  noOutOrder: 'No outbound order',
  deleteSuccess: 'Delete success',
  deleteFail: 'Delete failed',
  batchDel: 'Batch Delete',
  selectLeastOne: 'Please select at least one item',
  versionFalse: "Request failed. Your version is incorrect. Please refresh the page and try again.",
  po: "Purchase Order",
  poi: "Purchase Order Item",
  so: "Sales Order",
  soi: "Sales Order Item",
  io: "Inbound Order",
  ioi: "Inbound Order Item",
  oo: "Outbound Order",
  ooi: "Outbound Order Item",
  co: "Count Order",
  coi: "Count Order Item",
  act: "Accounts Receivable",
  acti: "Accounts Receivable Item",
  pay: "Accounts Payable",
  payi: "Accounts Payable Item",
  req: "Demand Order",
  reqi: "Demand Order Item",
  quo: "Enquiry Order",
  loc: "Location",
  sp: "Sales Price",
  pp: "Purchase Price",
  cd: "Count Difference",
  user: "User",
  org: "Organization",
  supplier: "Supplier",
  bom: "BOM",
  pl: "Production Plan",
  reqest: "Request",
  export: "Export",
  inventories: "Delivery Note",
  matPurTmp: "Download Purchase Order Matching Template",
  genPuInv: "Match Purchase Order to Generate Delivery Note",
  suppInv: "Match Supplier to Generate Delivery Note",
  printSaleIn: "Finished Product Inbound Print",
  saleIn: "Finished Product Inbound",
  lotGetErr: "Batch generation failed, please contact the administrator",
  addNext: "Next",
  genLot: "Generate",
  noCodeWarn: "Items without inventory code will not generate batches",
  genAllLot: "Generate All Batches",
  colSet: "Select Display Columns",
  leastSetOneCol: "Select at least one column to display!",
  reqCanceled: "Query request cancelled",
  escPressed: "You pressed ESC, the query request was cancelled",
  noFiles: "No files",
};

export default common;
